<!--
  ~ Copyright (C) 2025 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<div class="bar-container">
  <div class="bar-row" *ngFor="let row of chartData">
    <div class="bar-title small">{{ row.label }}</div>
    <div class="bar-column">
      <div class="bar-box" *ngIf="row.score" [style.width.%]="(row.selectedCount / row.allResponsesCount) * 100">
        {{ row.selectedCount }}
      </div>
    </div>
  </div>
</div>
